module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/core-js/library/modules/_add-to-unscopables.js
// module id = 1258
// module chunks = 3